// test1618
(1618 && 0);
